"use strict";
/**
 * 对象深拷贝
 * @param obj
 * @returns {*}
 */
export function deepCopy(obj) {
    if (typeof obj !== 'object') {
        return obj;
    }
    var newobj = {};
    for (var attr in obj) {
        newobj[attr] = deepCopy(obj[attr]);
    }
    return newobj;
}

/**
 * 对象去空格
 * @param  {[type]} obj [description]
 * @return {[type]}     [description]
 */
export function tirm(obj){
    if(typeof obj !== 'object') {
        return obj;
    }
    if(Array.isArray(obj)){
      //是否为数组
        for(var i in obj){
            // console.log("数组：",i,obj[i]);
            obj[i] = tirm(obj[i]);
        }
    }else{
        for(var j in obj){
            // console.log("属性：",j,obj[j]);
            if(typeof obj[j] === 'string'){
                obj[j] = obj[j].replace(/(^\s*)|(\s*$)/g, "");
                // console.log("字符串：",j,obj[j]);
            }else{
                obj[j] = tirm(obj[j]);
            }
        }
    }

  return obj;

}



// WEBPACK FOOTER //
// ./src/utils/object.js